import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseNine/img1.webp";
import img2 from "../../../assets/img/warehouseStructure/warehouseNine/img2.webp";
import img3 from "../../../assets/img/warehouseStructure/warehouseTen/img3.webp";

function WarehouseTen() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={300}>
      <div className={`warehouseTen ${isVisible ? "visible" : ""}`}>
        <div className="nineImg">
          <img
            className={`img2 ${isVisible ? "visible" : ""}`}
            src={img3}
            alt=""
          />
        </div>
        <div className="nineText">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            <span>{t("warehouse_ten_title_span")}</span>
            <br />{t("warehouse_ten_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("warehouse_ten_text")}
          </p>
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default WarehouseTen;
